import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueResource from 'vue-resource'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import {store} from './store/store'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faSquareXmark } from '@fortawesome/free-solid-svg-icons'

library.add(faSquareXmark)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false



Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(VueRouter)

const firebaseConfig = {
  apiKey: "AIzaSyBGcpymTbHJMIzIQBLRIvV6I7UVms5NgI8",
  authDomain: "stage-rental-b0ac0.firebaseapp.com",
  projectId: "stage-rental-b0ac0",
  storageBucket: "stage-rental-b0ac0.appspot.com",
  messagingSenderId: "990636322501",
  appId: "1:990636322501:web:5d020ec9d60439da264aac"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

import Home from './components/Home.vue';
import Cart from './components/Cart.vue';
import dash from './components/dashboard.vue';
import product from './components/Product.vue';
import Login from './components/login.vue';
import SignUp from './components/Signup.vue';
import Orders from './components/Orders.vue';
import AdminDashboard from './components/adminDashboard.vue';
import Admin from './components/adminLogin.vue';
import shop from './components/Shop.vue';

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes:[
    {path: '/dash', name: 'dash', component: dash},
    {path: '/', name: 'Home', component: Home},
    {path: '/Product/:id', name: 'Product', component: product},
    {path: '/Cart', name: 'Cart', component: Cart},
    {path: '/login', name: 'login', component: Login},
    {path: '/signup', name: 'signup', component: SignUp},
    {path: '/Orders', name: 'orders', component: Orders},
    {path: '/admin', name: 'admin', component: Admin},
    {path: '/AdminDashboard', name: 'admindashboard', component: AdminDashboard},
    {path: '/shop', name: 'shop', component: shop}

  ]})



new Vue({
  vuetify,
  render: h => h(App),
  store: store,
  router: router
}).$mount('#app')
